var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "question-page"
  }, [_c('div', {
    staticClass: "question-page__header"
  }, [_c('h2', {
    staticClass: "question-page__title"
  }, [_vm._v("\n      Вопросы и ответы\n    ")]), _vm._v(" "), _c('h2', {
    staticClass: "question-page__title question-page__title_mobile"
  }, [_vm._v("\n      Вопросы\n    ")]), _vm._v(" "), _c('Button', {
    staticClass: "question-page__add",
    attrs: {
      "icon": "add",
      "theme": "white",
      "size": "33"
    },
    on: {
      "click": function ($event) {
        _vm.isActive = !_vm.isActive;
      }
    }
  }, [_vm._v("\n      Задать вопрос\n    ")])], 1), _vm._v(" "), _vm.isActive ? _c('div', {
    staticClass: "question-page__form"
  }, [_c('UIActionEntity', {
    key: "question",
    attrs: {
      "get": _vm.$api.question.addQuestion
    },
    on: {
      "success": _vm.addQuestionHandler
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var get = _ref.get,
            status = _ref.status,
            error = _ref.error;
        return [_c('AnswerForm', {
          attrs: {
            "product-id": _vm.response.product.id,
            "status": status,
            "error": error,
            "height": 120
          },
          on: {
            "send": function ($event) {
              get($event), _vm.emitter.emit('submit-form-data', {
                email: $event.email
              });
            }
          }
        })];
      }
    }], null, false, 72825574)
  })], 1) : _vm._e(), _vm._v(" "), _c('DataEntityList', {
    attrs: {
      "get": _vm.$api.question.getByProductID,
      "get-list": _vm.wrapFunc(function (res) {
        return res === null || res === void 0 ? void 0 : res.question;
      }),
      "params": {
        id: _vm.response.product.id,
        size: 7
      },
      "get-pagination-data": _vm.wrapFunc(function (res) {
        return res === null || res === void 0 ? void 0 : res.pagination;
      })
    },
    on: {
      "success": function ($event) {
        _vm.list = $event.list;
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref2) {
        var loading = _ref2.loading,
            questionResponse = _ref2.response,
            error = _ref2.error,
            initialLoad = _ref2.initialLoad,
            itemsCount = _ref2.itemsCount,
            pageCount = _ref2.pageCount,
            pageCurrent = _ref2.pageCurrent,
            loadMore = _ref2.loadMore,
            changePage = _ref2.changePage;
        return [loading && initialLoad ? _c('StatusBlock', {
          attrs: {
            "size": "m",
            "type": "loading"
          }
        }) : error ? _c('Note', {
          staticClass: "product-page__creation-note",
          attrs: {
            "theme": "reddish"
          }
        }, [_vm._v("\n      " + _vm._s(questionResponse || 'Что то пошло не так') + "\n    ")]) : [_vm.list && _vm.list.length ? _c('div', {
          ref: "startQuestion"
        }, [_c('ViewportToogle', {
          scopedSlots: _vm._u([{
            key: "desktop",
            fn: function () {
              return _vm._l(_vm.list, function (item) {
                return _c('div', {
                  key: item.id,
                  staticClass: "question-page__question-item"
                }, [_c('Question', {
                  attrs: {
                    "question": item,
                    "product-id": _vm.response.product.id,
                    "data-e2e": "product-question-block"
                  },
                  on: {
                    "report": function ($event) {
                      return _vm.enableReport(_vm.response.product.id);
                    },
                    "add-answer": _vm.addAnswerHandler
                  }
                })], 1);
              });
            },
            proxy: true
          }, {
            key: "mobile",
            fn: function () {
              return _vm._l(_vm.list, function (item) {
                return _c('div', {
                  key: item.id,
                  staticClass: "question-page__question-item"
                }, [_c('QuestionMobile', {
                  attrs: {
                    "question": item,
                    "product-id": _vm.response.product.id,
                    "data-e2e": "product-question-block"
                  },
                  on: {
                    "click": function ($event) {
                      return _vm.$router.push(item.id);
                    },
                    "click-answer": function ($event) {
                      return _vm.$router.push(((item.id) + "?activeField=true"));
                    },
                    "report": function ($event) {
                      return _vm.enableReport(_vm.response.product.id);
                    }
                  }
                })], 1);
              });
            },
            proxy: true
          }], null, false, 2355080465)
        }), _vm._v(" "), itemsCount > 7 && pageCurrent && pageCount ? _c('div', {
          staticClass: "mt-25"
        }, [_c('TSHybridPagination', {
          attrs: {
            "quantity-on-page": 7,
            "pagination": {
              count: pageCount,
              current: pageCurrent,
              itemQuantity: itemsCount
            },
            "entities-list": ['вопрос', 'вопроса', 'вопросов']
          },
          on: {
            "change-page": function ($event) {
              changePage($event), _vm.onScrollTop();
            },
            "load-more": loadMore
          }
        })], 1) : _vm._e()], 1) : _c('Note', {
          staticClass: "product-page__creation-note"
        }, [_vm._v("\n        Задайте интересующий вас вопрос и мы непременно вам ответим :)\n      ")])]];
      }
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }